// components/ActivityTabs.jsx
export default function ActivityTabs({ activeTab, setActiveTab }) {
  return (
    <ul className="nav nav-tabs" id="myTab" role="tablist">
      <li className="nav-item" role="presentation">
        <button
          className={`nav-link ${activeTab === "activities" ? "active" : ""}`}
          id="home-tab"
          type="button"
          role="tab"
          onClick={() => setActiveTab("activities")}
        >
          My Activities
        </button>
      </li>
      <li className="nav-item" role="presentation">
        <button
          className={`nav-link ${activeTab === "unstake" ? "active" : ""}`}
          id="profile-tab"
          type="button"
          role="tab"
          onClick={() => setActiveTab("unstake")}
        >
          My Unstake
        </button>
      </li>
    </ul>
  );
}
